/**
 * レスポンスを検証する
 * 1. 1件以上存在すること
 * 2. 正しいJSONフォーマットであること
 * @returns ok: true, ng: false
 */
export const check = (res: Record<string, unknown>): boolean => {
  try {
    if (typeof res === 'string') {
      JSON.parse(res)
    }
    // フォーマット異常
  } catch (e) {
    return false
  }

  return true
}
